import { suspend } from "effection";
import {
  createApi,
  createThunks,
  Err,
  mdw,
  Ok,
  put,
  select,
  sleep,
  spawn,
  take,
} from "starfx";

import { insiderService, service } from "@app/service";

import { schema } from "./schema";
import { processSkipForwardPersistor } from "./selectors/applog.sel";
import { mainWorker } from "./workers/workerApi";

import type { Next, ApiCtx, Result, Operation } from "starfx";
import type { ThunkCtx } from "@app/types";
export const xouterApi = createApi<ApiCtx>();
xouterApi.use(mdw.err);
xouterApi.use(mdw.api({ schema }));
xouterApi.use(xouterApi.routes());
xouterApi.use(mdw.queryCtx);
xouterApi.use(mdw.nameParser);
xouterApi.use(mdw.fetch({ baseUrl: service }));

export const xApi = createApi<ApiCtx>();
xApi.use(mdw.err);
xApi.use(mdw.api({ schema }));
xApi.use(xApi.routes());
xApi.use(mdw.queryCtx);
xApi.use(mdw.nameParser);
xApi.use(mdw.fetch({ baseUrl: insiderService }));

export const xThunk = createThunks<ThunkCtx>();
xThunk.use(mdw.err);
xThunk.use(mdw.actions);
xThunk.use(xThunk.routes());

function* waitMdw(ctx: ApiCtx, next: Next) {
  yield* spawn(function* () {
    // opti , pessi,
    if (!["/get-wait", "/wait"].some((x) => ctx.key.startsWith(x))) {
      yield* sleep(1);
      ctx.json = Ok("posted");
    } else {
      yield* sleep(8000);
      ctx.json = Err(new Error("timeout"));
    }
    yield* put({ type: `/bailout${ctx.key}` });
  });

  yield* next();

  while (true) {
    const workerResult = yield* take([
      `/wresult${ctx.key}`,
      `/bailout${ctx.key}`,
    ]);
    if (workerResult.type === `/wresult${ctx.key}`) {
      ctx.json = workerResult.payload as Result<any>;
    }
    break;
  }
}

export function debounceEndpoints(
  timer: number = 1 * 1000,
  endpoints: string[]
) {
  let timerIsRunning = false;
  function* startTimer(): Operation<void> {
    timerIsRunning = true;
    yield* sleep(timer);
    timerIsRunning = false;
  }
  return function* onIncoming(ctx: ThunkCtx, next: Next) {
    const actionName = ctx.name.split("[").shift().trim();
    if (timerIsRunning) {
      if (endpoints.includes(actionName)) {
        ctx.key = "out";
      }
    } else {
      if (endpoints.includes(actionName)) {
        timerIsRunning = true;
        ctx.key = "in";
        yield* startTimer();
      } else {
        ctx.key = "out";
      }
    }
    yield* next();
  };
}

export const xWorker = createApi<ApiCtx>();
xWorker.use(mdw.err);
xWorker.use(mdw.api({ schema }));
xWorker.use(xWorker.routes());
xWorker.use(mdw.queryCtx);
xWorker.use(mdw.nameParser);
xWorker.use(mainWorker);
xWorker.use(waitMdw);

export const xDbc = createThunks<ThunkCtx>();
xDbc.use(mdw.err);
xDbc.use(debounceEndpoints(15000, ["/debounceThx"]));
xDbc.use(mdw.actions);
xDbc.use(xDbc.routes());
